(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bs-workflow-header"] && !Shopify.designMode) return;
  try {
    const bsInitializeHeaderCart = () => {
    document.querySelectorAll('[data-bs-header-cart]').forEach((wrapper) => {
      if (wrapper.dataset.bsCartObserved) return;
      wrapper.dataset.bsCartObserved = 'true';
      const updateVisibility = () => {
        const count = wrapper.querySelector('.cart-count-bubble [aria-hidden="true"]');
        wrapper.hidden = !count || Number.parseInt(count.textContent, 10) === 0;
      };
      updateVisibility();
      new MutationObserver(updateVisibility).observe(wrapper, { childList: true, subtree: true, characterData: true });
    });
  };
  bsInitializeHeaderCart();
  document.addEventListener('shopify:section:load', bsInitializeHeaderCart);

  document.addEventListener('toggle', (event) => {
    if (!event.target.matches('[data-bs-nav-group]')) return;
    event.target.querySelector('summary').setAttribute('aria-expanded', String(event.target.open));
  }, true);

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-bs-mobile-group-toggle]')) {
      event.stopImmediatePropagation();
      return;
    }
    const closeButton = event.target.closest('[data-bs-drawer-close]');
    const menuLink = event.target.closest('[data-bs-drawer-link]');
    if (!closeButton && !menuLink) return;
    const drawer = event.target.closest('.bs-workflow-header__drawer');
    if (!drawer || typeof drawer.closeMenuDrawer !== 'function') return;
    if (closeButton) {
      event.stopImmediatePropagation();
      drawer.closeMenuDrawer(event, drawer.querySelector('summary'));
    } else {
      drawer.closeMenuDrawer(event);
    }
  }, true);

  document.addEventListener('keyup', (event) => {
    if (event.key !== 'Escape') return;
    const group = event.target.closest('[data-bs-nav-group][open]');
    if (group) {
      event.stopImmediatePropagation();
      group.open = false;
      group.querySelector('summary').focus();
      return;
    }
    const drawer = event.target.closest('.bs-workflow-header__drawer');
    if (!drawer || !drawer.querySelector('details[open]') || typeof drawer.closeMenuDrawer !== 'function') return;
    event.stopImmediatePropagation();
    drawer.closeMenuDrawer(event, drawer.querySelector('summary'));
  }, true);

  document.addEventListener('keydown', (event) => {
    const group = event.target.closest('.bs-workflow-header__disclosure');
    if (!group || event.key !== 'ArrowDown' || event.target !== group.querySelector('summary')) return;
    event.preventDefault();
    group.open = true;
    group.querySelector('a[href]')?.focus();
  });

  document.addEventListener('focusin', (event) => {
    document.querySelectorAll('.bs-workflow-header__disclosure[open]').forEach((group) => {
      if (!group.contains(event.target)) group.open = false;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
